import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';

import { RootState } from '../types/ModuleTypes';
import { processModule } from './processModule';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
    state: {
        showSidebar: false,
        fullNavbar: false,
        version: '1.0.0',
    },
    getters: {
        showSidebar: (state) => state.showSidebar,
        fullNavbar: (state) => state.fullNavbar,
        version: (state) => state.version,
    },
    actions: {
        setShowSidebar({ commit }, showSidebar) {
            commit('setShowSidebar', showSidebar);
        },
        setFullNavbar({ commit }, fullNavbar) {
            commit('setFullNavbar', fullNavbar);
        },
    },
    mutations: {
        setShowSidebar(state, showSidebar) {
            state.showSidebar = showSidebar;
        },
        setFullNavbar(state, fullNavbar) {
            state.fullNavbar = fullNavbar;
        },
    },
    modules: {
        processModule,
    },
};

export default new Vuex.Store<RootState>(store);
